<template>
  <div>

    <FormulateForm v-model="values" class="formulate-style-compact">

      <v-container>
        <v-row v-for="item in conditionalSchema" :key="item.uuid">
          <v-col class="pa-0">
            <eform-element
                :element="item"
                :disabled-prop="setDisabled(item)"
                v-show="isVisuallyShown(item)"
                :is-admin-mode="false"
                :values="values"
                :schema="schema"
                @subform-values-changed="subformValuesChanged"
            />

          </v-col>
        </v-row>
      </v-container>
    </FormulateForm>

    <p v-if="!myForm.schema.length">Er zijn nog geen velden toegevoegd aan dit formulier.</p>

  </div>
</template>

<script>
import folderHelpers from "@/mixins/folderHelpers";
import EformElement from "@/components/EformElement.vue";
import eformConditionals from "@/mixins/eformConditionals";
import eformHelpers from "@/mixins/eformHelpers";

export default {
  name: "FormPreview",
  components: {EformElement},
  mixins: [
      folderHelpers,
      eformConditionals,
      eformHelpers,
  ],
  props: {
    myForm: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      template: '',
    }
  },
  async mounted () {

  },
  computed: {
    values: {
      get() {
        return this.myForm.values;
      },
      async set(values) {
        this.myForm.values = values;
      }
    },
    schema: {
      get() {
        return this.myForm.schema;
      }
    },
    rules: {
      get() {
        return this.myForm.rules;
      }
    },
  },
  methods: {
    setDisabled(item) {
      return (item.elementType === 'file' || item.elementType === 'image' || item.elementType === 'linkedForm');
    },
    isVisuallyShown(item) {
      if (item.visuallyHidden) {
        return false;
      }
      return true;
    },
  }
}
</script>

<style scoped>

</style>